// extracted by mini-css-extract-plugin
export default {"badge":"Badge_badge__YvtC6","active":"Badge_active__uNk5y","pending":"Badge_pending__R0uut","failed":"Badge_failed__9ToZA","inactive":"Badge_inactive__-R2z1"};